import { useEffect } from 'react';
import { api } from '@/App';
import { track } from '@/lib/analytics';

/**
 * Fire-and-forget tool-usage tracking. Mount this hook on any planning tool
 * page so the backend learns which tools the user has tried — used by the
 * Beta Feedback banner trigger (>=3 tools).
 */
const useTrackToolUsage = (tool) => {
  useEffect(() => {
    if (!tool) return;
    api.post('/tool-usage/track', { tool }).catch(() => { /* non-critical */ });
    track('tool_viewed', { tool });
  }, [tool]);
};

export default useTrackToolUsage;
